<script>
export default {
	name: 'MenuItem',
	functional: true,
	props: {
		icon: {
			type: String,
			default: ''
		},
		title: {
			type: String,
			default: ''
		},
		disabled: {
			type: Boolean,
			default: false
		},
		unreadCount: {
			type: Number,
			default: 0
		}
	},
	render(h, context) {
		const { icon, title, disabled, unreadCount } = context.props;
		const vnodes = [];
		const disabledStyle = disabled ? {} : {};

		if (icon) {
			if (icon.startsWith('https://')) {
				// External icon (URL) - render as image
				vnodes.push(<img src={icon} style='width: 1em; height: 1em; vertical-align: middle; margin-right: 16px;' />);
			} else {
				// Internal icon - render as svg-icon
				vnodes.push(<svg-icon icon-class={icon} style='color:#ed6b1c; vertical-align: middle;' />);
			}
		}

		if (disabled) {
			vnodes.push(
				<span slot='title' style='font-size:12px; display: inline-flex; justify-content: space-between; width: 145px; align-items: center;'>
					{ title }
					<i class='el-icon-lock' style='display: inline-flex; align-items: center; font-size: 16px;'></i>
				</span>
			);
		} else if (unreadCount > 0) {
			vnodes.push(
				<span slot='title' style='font-size:12px; display: inline-flex; justify-content: space-between; width: 145px; align-items: center;'>
					{ title }
					<el-badge value={unreadCount} style='margin-left: 5px;'></el-badge>
				</span>
			);
		} else {
			vnodes.push(
				<span slot='title' style='font-size:12px; align-items: center;'>
					{ title }
				</span>
			);
		}

		return vnodes;
	}
};
</script>
